import "../../chunk-7QVYU63E.js";
import { ProjectType } from "#signup/signup.js";
const projectTypeLabels = {
  [ProjectType.Analytics]: "Analytics",
  [ProjectType.Defi]: "DeFi",
  [ProjectType.Gaming]: "Gaming",
  [ProjectType.Wallet]: "Wallet",
  [ProjectType.Security]: "Security",
  [ProjectType.Social]: "Social",
  [ProjectType.Marketplace]: "Marketplace",
  [ProjectType.InfraAndTooling]: "Infra & Tooling",
  [ProjectType.NFTs]: "NFTs",
  [ProjectType.Identity]: "Identity"
};
export {
  projectTypeLabels
};
//# sourceMappingURL=projectTypeLabels.js.map